import React, { ComponentProps, FC } from 'react';
import { BaseButton, Icon } from '@common/components';

type BaseProps = ComponentProps<typeof BaseButton>;

type AddButtonProps = Omit<BaseProps, 'icon'> & {
  showDropdown?: boolean;
};

export const AddButton: FC<AddButtonProps> = ({
  children,
  showDropdown = false,
  type = 'default',
  ...props
}) => (
  <BaseButton
    {...props}
    type={type}
    icon={<Icon icon="plus" kind="light" />}
    style={{ display: 'flex', alignItems: 'center', ...props.style }}
  >
    {children}
    {showDropdown && (
      <Icon icon="chevronDown" size="sm" kind="regular" color="steelDarker" />
    )}
  </BaseButton>
);
